export const STICKY_RAIL_MODULE_CONTAINER_CLASS = 'wds-viewability-slider__module';
export const STICKY_RAIL_MODULE_STICKY_CLASS = 'wds-viewability-slider__sticky';
